<template>
  <div class="download-list-container">
    <div v-if="filesList.length !== 0">
      <h1 class="download-list-title">List of bdd dumps to Download {{ name[0] }}</h1>
      <ul class="download-list">
        <li v-for="(file, index) in displayedFiles" :key="index">
          <a class="file-link" @click="downloadFile(file.name)">{{ file.name }}</a>
          <span class="file-size">{{ file.size }}</span>
          <span class="file-date">{{ file.date | formatDate }}</span>
        </li>
      </ul>
      <div class="paginate-buttons">
        <v-btn class="btnPaginate" fab color="primary" @click="goToPreviousPage" :disabled="currentPage === 0">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn class="btnPaginate" fab color="primary" @click="goToNextPage" :disabled="currentPage === totalPages - 1">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="btn" fab color="primary" @click="downloadAll" v-bind="attrs" v-on="on">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>Files are large. Download may take several minutes !</span>
      </v-tooltip>
    </div>
    <div v-else>
      <p class="empty-message">No bdd dumps available for download.</p>
      <p class="attract-message">Please check back later for updated dumps.</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Array,
    files: Array,
  },
  data: () => ({
    currentPage: 0,
    filesPerPage: 5,
  }),
  filters: {
    formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleString('fr-FR');
    }
  },
  methods: {
    downloadAll: async function () {
      window.location.assign(
        process.env.VUE_APP_API_EXT_URL +
        "/kiosk/getFiles/" +
        this.name[0] +
        "?tkn=" +
        localStorage.getItem("jwt")
      );
    },
    downloadFile: async function (file) {
      window.location.assign(
        process.env.VUE_APP_API_EXT_URL +
        "/kiosk/getFile/" +
        this.name[0] +
        "/" +
        file +
        "?tkn=" +
        localStorage.getItem("jwt")
      );
    },
    goToPreviousPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
      }
    }
  },
  computed: {
    name() {
      return this.$props.data;
    },
    filesList() {
      return this.$props.files;
    },
    displayedFiles() {
      const startIndex = this.currentPage * this.filesPerPage;
      const endIndex = startIndex + this.filesPerPage;
      return this.filesList.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.filesList.length / this.filesPerPage);
    },
  }
}
</script>
<style>
.container {
  position: relative;
  height: 100%;
}
.btn {
  position: absolute;
  bottom: 24px;
  right: 24px;
}
.download-list-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(80% - 64px);
  /* Substract the height of the AppBar from the viewport height */
}
.download-list-title {
  font-size: 20px;
  margin-bottom: 16px;
}
.download-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.download-list li {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.file-size, .file-date {
  white-space: nowrap;
}
.download-list a {
  text-decoration: none;
  color: #2196f3;
}
.empty-message {
  font-size: 24px;
  color: red;
}
.attract-message {
  font-size: 18px;
  color: gray;
}
.file-link {
  margin-right: 80px;
}
</style>